import React from 'react'
import { Link } from 'react-router-dom'
import HelpModal from './HelpModal'
import { userService } from '../../_services/user.service'
import { APP_NAME, TAGLINE } from '../../brand'

class Footer extends React.Component {
  constructor(props) {
    super(props)
    this.state = { showHelp: false }
  }

  render() {
    var user = userService.currentUserValue
    return (
      <footer className="ng-footer">
        <div className="ng-footer-inner">
          <div>
            <Link to="/" className="ng-logo ng-footer-logo ng-wordmark">
              <span className="ng-wordmark-key">⌂</span>
              <span>{APP_NAME}</span>
            </Link>
            <p className="ng-footer-about">
              {TAGLINE}. Buyer's agents post showings and name the fee — verified
              local agents cover them and report back. Agents helping agents.
            </p>
          </div>
          <ul className="ng-footer-links">
            <li>
              <Link to="/showings/post">Post a showing</Link>
            </li>
            <li>
              <Link to="/jobs">Find showings</Link>
            </li>
            <li>
              <a href="/#how-it-works">How it works</a>
            </li>
            <li>
              <Link to="/tos">Terms of service</Link>
            </li>
            <li>
              <Link to="/privacy">Privacy policy</Link>
            </li>
            {user ? (
              <li>
                <button
                  className="ng-footer-link-btn"
                  onClick={() => this.setState({ showHelp: true })}
                >
                  Get help
                </button>
              </li>
            ) : null}
          </ul>
          {this.state.showHelp ? (
            <HelpModal onClose={() => this.setState({ showHelp: false })} />
          ) : null}
        </div>
        <div className="ng-footer-bottom">
          © {new Date().getFullYear()} {APP_NAME}. All rights reserved.
        </div>
      </footer>
    )
  }
}

export default Footer
